import Vue from 'vue';

import { buildUpdateMutations } from '@/store/extensions/update';
import { buildCreateMutations } from '@/store/extensions/create';

export default {
  ...buildCreateMutations(['createProfile']),
  ...buildUpdateMutations(['updateProfile']),

  openFormModal: (state) => {
    Vue.set(state, 'formModalOpened', true);
  },

  closeFormModal: (state) => {
    Vue.set(state, 'formModalOpened', false);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js